export type PatternType = keyof typeof patterns;

type Props = {
  pattern: PatternType;
};

const patterns = {
  dotted: {
    url: "/pattern-dot.svg",
    size: 16,
  },
  grid: {
    url: "/pattern-grid.svg",
    size: 12,
  },
  none: undefined,
} as const;

export function Pattern(props: Props) {
  const { pattern: _pattern } = props;

  const pattern = patterns[_pattern];

  if (!pattern) {
    return null;
  }

  return (
    <div
      tw="absolute inset-0 pointer-events-none"
      style={{ background: `url(${pattern.url}) repeat`, backgroundSize: pattern.size }}
    />
  );
}
